import { useMutation } from '@tanstack/react-query';
import { rpcClient } from '@/api/rpc/client';
import { useToast } from '@/context/ToastContext';
import type { UiBugReportContext } from '@erp/rpc';

export interface SubmitUiBugReportInput {
  message: string;
  screenshotDataUrl?: string | null;
  context: UiBugReportContext;
}

export function useSubmitUiBugReport() {
  const { showToast } = useToast();

  return useMutation<{ success: boolean }, Error, SubmitUiBugReportInput>({
    mutationFn: async (input) => {
      return await rpcClient.core.uiBugReport.submit(input);
    },
    onSuccess: () => {
      showToast({
        title: 'Feedback sent',
        message: 'Thanks for helping us improve the product.',
        color: 'success',
        icon: 'check',
      });
    },
    onError: (error) => {
      showToast({
        title: 'Could not send feedback',
        message: error.message,
        color: 'error',
        icon: 'x',
      });
    },
  });
}
